//@ts-nocheck
import React from 'react';
import { EditBase, TopToolbar, useGetOne, useRecordContext } from 'react-admin';
import {
	Card,
	CardContent,
	Grid,
	Typography,
	MenuList,
	MenuItem,
	ListItemIcon,
	ListItemText,
} from '@mui/material';
import { Route, Routes, useNavigate, useParams } from 'react-router';
import InfoIcon from '@mui/icons-material/Info';
import TableChartIcon from '@mui/icons-material/TableChart';
import { ConnectorConfigInfos } from './ConnectorConfigInfos';
import { ConnectorConfigPrebuilds } from './ConnectorConfigPrebuilds';

const w = window as any;

const Breadcrumb = () => {
	const record = useRecordContext();
	return (
		<TopToolbar>
			<Typography variant="subtitle1">
				Home / Connectors / {record ? record.name : 'Config'} / Configuration
			</Typography>
		</TopToolbar>
	);
};

export const ConnectorConfigHome = (props: any) => {
	const { id } = useParams();
	const navigate = useNavigate();
	const { data: record, isLoading } = useGetOne('connectors', { id });

	const logoUrl = record ? `${w.FRONT_URL}/img/connectors-logos/${record.sku}.svg` : '';

	if (isLoading || !record) return null;

	return (
		<EditBase {...props} id={id} resource="connectors">
			<>
				<Breadcrumb />
				<Grid container spacing={2}>
					<Grid item xs={8}>
						<Routes>
							<Route index element={<ConnectorConfigInfos />} />
							<Route path="prebuilds" element={<ConnectorConfigPrebuilds />} />
						</Routes>
					</Grid>
					<Grid item xs={4}>
						<Card>
							<CardContent>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: 8,
										marginBottom: 16,
									}}
								>
									<img
										src={logoUrl}
										alt=""
										style={{
											width: 25,
											height: 25,
											objectFit: 'contain',
										}}
									/>
									<Typography variant="h6" gutterBottom sx={{ mb: 0 }}>
										{record.name}
									</Typography>
								</div>
								<Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
									SKU: {record.sku}
								</Typography>
								<MenuList>
									<MenuItem onClick={() => navigate('.')}>
										<ListItemIcon>
											<InfoIcon fontSize="small" />
										</ListItemIcon>
										<ListItemText>Informations</ListItemText>
									</MenuItem>
									<MenuItem onClick={() => navigate('prebuilds')}>
										<ListItemIcon>
											<TableChartIcon fontSize="small" />
										</ListItemIcon>
										<ListItemText>Prebuilds</ListItemText>
									</MenuItem>
								</MenuList>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</>
		</EditBase>
	);
};
